const dataDokumentasi = {
    FOTO: [
        {
            divisi: "Gandara",
            koordinator: [],
            bph: [
                { nama: "Ralph Theodoric", jabatan: "Supervisi" },
                { nama: "Wilcoustine Pniel", jabatan: "Ketua" },
                { nama: "Jehezkiel Immanuel", jabatan: "Wakil Ketua" },
                { nama: "Cecillia Abbygail", jabatan: "Sekretaris 1" },
                { nama: "Idayu Ringandani", jabatan: "Sekretaris 2" },
                { nama: "Assyifa Salsabila", jabatan: "Bendahara" },
            ],
            kelompok: [
                {
                    indexkelompok: "kelompok1",
                    anggota: [],
                },
            ],
        },
        {
            divisi: "Balwana",
            koordinator: ["Lavia Jovelin", "Gloria Wijaya", "Kenny Adam"],
            kelompok: [
                {
                    indexkelompok: "kelompok1",
                    anggota: [
                        "Derren Pranata",
                        "Fransisca Lee",
                        "Jennifer Arcelia",
                        "Joselino Frederick",
                        "Livianny Allycia",
                        "Louissa Sofia",
                        "Shareefa Aisyah",
                    ],
                },
            ],
        },
        {
            divisi: "Caksana",
            koordinator: ["Afiq Walid", "Divi Afrilia"],
            kelompok: [
                {
                    indexkelompok: "kelompok1",
                    anggota: [
                        "Cherish Dominick",
                        "Rachel Natallie",
                        "Ferdinand Julius",
                        "Stefani Margaretha",
                        "Paramitha Irgina",
                        "Silvia Andriyani",
                        "Beatrice Ellena",
                        "Lawrencia",
                        "Gabriela Salim"],
                },
            ],
        },
        {
            divisi: "Lavanya",
            koordinator: ["Gabrielle Wibowo", "Jessica Marella"],
            kelompok: [
                {
                    indexkelompok: "kelompok1",
                    anggota: [
                        "Rara Anggreni",
                        "David Wang",
                        "Ruus, Auliana",
                        "Qonita Azalia",
                        "Stacyana Susanto",
                    ],
                },
            ],
        },
        {
            divisi: "Bimasena",
            koordinator: ["Marcellino", "Fathan Nasution", "Auralia Dwi"],
            kelompok: [
                {
                    indexkelompok: "kelompok1",
                    anggota: [
                        "Adriano Bimo",
                        "Dindaniz",
                        "Keane Subrata Halim",
                        "Nadine Ayu Putri Ramadhani",
                        "Daffa Surya Pramudya",
                        "Zerounia Meisya Widyanto",
                        "Nathanael Clarence Sariono",
                        "Livinia Cathleen",
                        "Richard Giansanto",
                        "Ferry Halim",
                        "Theola Alvarizka",
                        "Radian Putra Arbiansyah",
                        "Belicia Vevila Latishia Paliama",
                        "Surya Novensky Tinus",
                        "Glend Yesaya Pulu",
                        "Naila Asylah Rivitri Lubis",
                        "Jeanette Aprilia Ongah",
                        "Philipe Edwardo",
                    ],
                },
                {
                    indexkelompok: "kelompok2",
                    anggota: [
                        "Samuel Matthew Irawan",
                        "Muhammad Rizky Ardana",
                        "Beneisha Bat",
                        "Geofrey Mercyo",
                        "⁠Maryellen Eunike",
                        "Gregorius Gigih",
                        "Geovandy O' Feliz",
                        "Lia Priyatiningrum",
                        "Ricardo Cipta",
                        "Made Arya",
                        "Raffael Valentino Gunawan",
                        "Wilson Hermawan",
                        "Fransiskus Bagas",
                        "Angelica Victoria Cassandr",
                        "Olivier Rakha",
                        "Kheisha Twyla Noellisd",
                    ],
                },
                {
                    indexkelompok: "kelompok3",
                    anggota: [
                        "Andriana Cipta Wijaya",
                        "Marchel Halim",
                        "Felisiana",
                        "Darryl Cornelius Setiawan",
                        "⁠Leory Lee",
                        "Petrus Bonaventura Ratuanik",
                        "Farrel",
                        "Lyvia Rose Zanisya",
                        "William Purba",
                        "Clementia Chessa Gunawan",
                        "Thomas Daviniel",
                        "Japhia Jehosheba Roa Tjiptamustika",
                        "⁠Cecilia Margaretha",
                        "Benediktus Deamaren",
                        "Mohamad Vidie Afriyano",
                        "Ryane Kalyana El Deeri",
                        "Alexa Putri Wiharto",
                        "Meldean Jonathan",
                    ],
                },
            ],
        },
        {
            divisi: "Baskara",
            koordinator: ["Ravalen Virginia"],
            kelompok: [
                {
                    indexkelompok: "kelompok1",
                    anggota: [
                        "Andrew Su",
                        "Margareth Ritonga",
                        "Maria Oxa Surysia",
                        "Diana Angyulia",
                        "Valentino Kriswahyudi",
                        "Qhedyzya Ricardiane Da Costa Ribeiro",
                        "Salman Aqil Munandar",
                        "Maria Cahaya Amomanta Wirastu",
                        "Kristian Delon",
                        "Steven Hans",
                        "Allison Gressia Chaniago",
                        "Sakti Yudha",
                        "Yohanes Govinda Agarota",
                        "Raden Muhamad Fauzan Habrari",
                        "I Putu Ari Sastra",
                        "Darren",
                        "Elizabeth Larasati",
                        "Made rama Yoga Wibawa",
                        "Rava Parisya",
                    ],
                },
            ],
        },
        {
            divisi: "Gajendra",
            koordinator: [
                "Hellen Herlina",
                "Michael Lucius",
                "Agym Dimas Tian",
            ],
            kelompok: [
                {
                    indexkelompok: "kelompok1",
                    anggota: [
                        "Alfonsus Aryaveda",
                        "Audy Hendry",
                        "Exan Putra",
                        "Fransiskus Asisi",
                        "Juantama",
                        "Kevin Rakhmad",
                        "Koong Hiap",
                        "Luthfansya Haikal ",
                        "Raihan Maulidar",
                        "Ignatius Rayden",
                        "Reynard Geovanni",
                        "Muhammad Salman ",
                        "Ananda Refi",
                        "Nicholas Nelson",
                        "Muhammad Irfan",
                    ],
                },
            ],
        },
        {
            divisi: "Sakha",
            koordinator: [
                "Farion Tekkry",
                "Steven Feliciano Wiggins",
                "Clarissa Elvira Darmawan",
                "Charlotte Yeung",
            ],
            kelompok: [
                {
                    indexkelompok: "kelompok1",
                    anggota: [
                        "Jessie Yenca",
                        "Hawari Putra",
                        "Christalin Barbietta",
                        "Indah Safitri",
                        "Alroy Reynardo",
                        "Airin Maitri",
                        "Dicky Rusandana",
                        "Darlene Chryshilla",
                        "Natan Adi",
                        "Ivana Fifinella",
                        "Naura Sita",
                        "Khaira Khansa",
                        "Melda Rantika",
                        "Putri Videlia",
                        "Rafael Nicholas",
                        "Angeliqe Isabel",
                        "Sean Rizkiardy",
                        "Cassia Wulandari",
                        "Dennis Aaron",
                        "Jeremy Dominic",
                    ],
                },
                {
                    indexkelompok: "kelompok2",
                    anggota: [
                        "Angelica Meideline",
                        "Umi Salamah",
                        "Dhaniel Chang",
                        "Livia Hadi",
                        "Wizart Keane",
                        "Kezia Elia",
                        "Richie Giansanto",
                        "Claditte Qisthidarari",
                        "Christian Yoga",
                        "Jenice Aurelia",
                        "Maddava Arya",
                        "Rahadina Adisty",
                        "James Arpiar",
                        "Jennifer Jannice",
                        "Muhammad Kynan",
                        "Aurelia Keianne",
                        "Glen Andrian",
                        "Gabriel Felicia",
                        "Velisya Angi",
                    ],
                },
                {
                    indexkelompok: "kelompok3",
                    anggota: [
                        "Jose Antonio",
                        "Kayla Abbiegail",
                        "Audrey Naoko",
                        "Cindy Fidelia",
                        "Francisco Anderson",
                        "Kezia Laurencia",
                        "Lifkie Lie",
                        "Cherine",
                        "Filbert Fausto",
                        "Jolin Stefanie",
                        "Bryant Sachio",
                        "Richard Sanjaya",
                        "Lovenia Kirana",
                        "Chellensya Beatrice",
                        "Alya Virgia",
                        "Elsa Shaqia",
                        "Enrico Felix",
                        "Carin Indra",
                        "Nashaffa Novadhan",
                    ],
                },
                {
                    indexkelompok: "kelompok4",
                    anggota: [
                        "Daniel Gouwardi",
                        "Shanne Nichole",
                        "Benedictus Agsel",
                        "Putri Aurelia",
                        "Kiev Immanuel",
                        "Fenny Caroline",
                        "Samantha Luvian",
                        "Chaterine Laurenthia",
                        "Maulana Rivai",
                        "Felita Aileen",
                        "Gabriel Javito",
                        "Tirtayani Padmasari",
                        "Kelvin Sutadi",
                        "Elena Coarin",
                        "Florence Callista",
                        "Alya Geraldine",
                        "Bryan Emmanuel",
                        "Angeline Lie",
                    ],
                },
                {
                    indexkelompok: "kelompok5",
                    anggota: [
                        "Chairin Thamrin",
                        "Charmaine Astrella",
                        "Varrel Noas",
                        "Marvella Charissa",
                        "Vina Centiawan",
                        "Desmonda Felim",
                        "Samuel Fernandtio",
                        "Zahwa Marliana",
                        "Felix",
                        "Sharly Pravda",
                        "Axel Leopulisa",
                        "Felicia Frelli",
                        "Rafi Raditya",
                        "Rehuel Tisya",
                        "Michelle Angelina",
                        "Catherine Harlinata",
                        "Vincentius Rafael",
                        "Patricia Huang",
                        "William Kwok",
                        "Evelyn Vania",
                    ],
                },
                {
                    indexkelompok: "kelompok6",
                    anggota: [
                        "Nadine Starleen",
                        "Ronald Ramlian",
                        "Fikri Ekandra",
                        "Yudith Rahmadiah",
                        "Daniel Geraldy",
                        "Carolyne Kyneisha",
                        "Alexander Briant",
                        "Metta Florensia",
                        "Dylan Ervian",
                        "Felicia Mardjuki",
                        "Michael Tamba",
                        "Amira Maritza",
                        "Cerina Kahayani",
                        "Yuliani",
                        "Stanislaus Jasson",
                        "Michelle Fernanda",
                        "Jonathan Suryajaya",
                        "Valencia Fiorentina",
                        "Keira Nicole",
                    ],
                },
                {
                    indexkelompok: "kelompok7",
                    anggota: [
                        "Feodrian Calvin",
                        "Airin Frantrishia",
                        "Feinisia Andani",
                        "Benedict William",
                        "Devina Setiawan",
                        "Felix Octaniel",
                        "Abigail Vania",
                        "Ryan Erlanda",
                        "Muhammad Iqbal",
                        "Joycelyn Sharon",
                        "Callista Feodora",
                        "Fakhira Putri",
                        "Graciella Nathania",
                        "Celvin Cristyanto",
                        "Anna Hanafi",
                        "Kayla Nugroho",
                        "Adeline Gracia",
                        "Melvie Ho",
                    ],
                },
                {
                    indexkelompok: "kelompok8",
                    anggota: [
                        "Luviola Hanum",
                        "Betrand Cornelius",
                        "Chiara Andini",
                        "Kevin Thenggano",
                        "Celine Grace",
                        "Feri Rifki",
                        "Vito Nathayo",
                        "Eugenia Fidella",
                        "Felicia Jennifer",
                        "Maximized William",
                        "Amanda Citra",
                        "Carmella Fitrya",
                        "Aryabell Boston",
                        "Kezia Graciella",
                        "Nicky Puji",
                        "Gavrila Liona",
                        "Brandon Sachio",
                        "Evelyn Valencia",
                        "Abel Oktavian",
                    ],
                },
            ],
        },
        {
            divisi: "Nayanika",
            koordinator: ["Daffa Akbari", "Jose Andreas Lie"],
            kelompok: [
                {
                    indexkelompok: "kelompok1",
                    anggota: [
                        "Axel Ferdinand",
                        "Kafijaya",
                        "Caleb Stebe Dinoto",
                        "Deswandy Wong",
                        "Kevin Ken",
                        "Valentino Fernando",
                    ],
                },
            ],
        },
        {
            divisi: "Sarkara",
            koordinator: ["Evan Yo", "Nasya Karina"],
            kelompok: [
                {
                    indexkelompok: "kelompok1",
                    anggota: [
                        "Jennifer Amanda",
                        "Kathleen Aurelia Chandra",
                        "Nayla Shakila Azzahra",
                        "Joy Rockniel Abadi",
                        "Larissa ika Kamila",
                        "Daniel Liao",
                        "Shavelle Gautami Japar",
                        "Batara Hotdo Horas Simbolon",
                        "Farrel Abimanyu Kalaiy",
                        "Annisa Maulia Syifa Kanayla",
                        "Syaif Cahyo Wijaya",
                        "Josephin Narumi Setiawan",
                        "Nadia sekar sari",
                        "Kevin Steven Kussoy",
                        "Vincentius Benedictus Martajaya",
                        "Marcell Daniel Tang",
                        "Benedikta Kumala Handayani",
                        "Tiffany Titania Sunarga",
                        "Frissa Budiansyah",
                        "Shu Evangeline Christiani Saputro",
                        "Yasmine Aghnia Pramono",
                    ],
                },
            ],
        },
        {
            divisi: "Saraya",
            koordinator: ["Andrew Susilo", "Jessica Sihasale"],
            kelompok: [
                {
                    indexkelompok: "kelompok1",
                    anggota: [
                        "Made Elsya Wardani",
                        "Puteri Novariqa",
                        "Venesia Alexandra",
                        "Rinny Marcela",
                        "Angel Tri Ivanka",
                        "Devina Hartamty",
                        "Euginia Felicia",
                        "Irene Berliana",
                        "Dhivie Chandra",
                        "Celestine",
                        "Vianca Vanesia",
                        "Amanda Charista",
                        "Marcella Gladys",
                        "Nazla Shafiradhianti",
                        "Made Amelia",
                        "Najwa Khairunisa",
                        "Angellica Kristie",
                        "Michael Elbert",
                        "Winson Sovian",
                        "Edbert Rendrahadi ",
                        "Parwin Singh",
                        "Fredlie Irwanto",
                        "Chandra Wijaya",
                        "Richard Bona",
                        "Ryu Ivan",
                        "Hieronimus Daniel",
                        "Savero Madajaya",
                        "Jeferson",
                    ],
                },
                {
                    indexkelompok: "kelompok2",
                    anggota: [
                        "Felicia Austin",
                        "Sara Emmanuella",
                        "Jacinda Amoret",
                        "Jesslyn Chlarysta",
                        "Lusia Trudy",
                        "Karyn Agnesia",
                        "Cordelie Kesita",
                        "Cellinne Chrysa",
                        "Jesslyn Gunawan",
                        "Emylia Izecson",
                        "Diana Paulina",
                        "Karen Jocelyn",
                        "Keisha Christianti",
                        "Patricia Evelyn",
                        "Tiara Natasya",
                        "Denia Eryza",
                        "Priscilla Septiana",
                        "Kellen Valerie",
                        "Vika Gisella",
                        "Dessy Chandra",
                        "Natasha Suhendra",
                        "Vania Vesakha",
                        "Priskila Agape",
                        "Elshaday Eoudia",
                        "Hakim Ulinnuha",
                        "Dimas Syahid",
                        "Novan Gustaf",
                        "Michael Theodore",
                        "Gerard Stefan",
                        "Aurel Dhiya",
                        "Jonathan Prasetyo",
                        "Yurcell Young",
                        "Ivan Nayottama",
                    ],
                },
            ],
        },
    ],
};

export default dataDokumentasi;
